import './assets/styles/index.css';

import * as Sentry from '@sentry/react';
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

import { initI18next } from '@/lib/i18n';

import { App } from './app';

if (['production', 'staging'].includes(import.meta.env.MODE)) {
  Sentry.init({
    dsn: 'https://08191a209e43fb65f1c0a042f8813098@o4510317782564864.ingest.de.sentry.io/4511064391614544',
    sendDefaultPii: true,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllInputs: false,
        blockAllMedia: false,
        maskAllText: false,
      }),
      Sentry.reactRouterBrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    // Tracing
    tracesSampleRate: 0.2,
    tracePropagationTargets: [import.meta.env.VITE_API_HOST],
    // Session Replay
    replaysSessionSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    // Enable sending logs to Sentry
    enableLogs: true,
  });
}

// The import greatly slows down the loading time in Firefox.
if (import.meta.env.DEV && typeof window !== 'undefined') {
  const { scan } = await import('react-scan');
  scan({
    enabled: true,
  });
}

await initI18next();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
